import { render, staticRenderFns } from "./SuccessfulCases.vue?vue&type=template&id=0b32814b&"
import script from "./SuccessfulCases.vue?vue&type=script&lang=js&"
export * from "./SuccessfulCases.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfulCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports